import { createAction, props } from '@ngrx/store';
import {
  EmailMemberships,
  ReportSchedule,
  LoadReportSchedulesPayload,
  DeleteReportSchedulePayload,
  CreateEmailSubscriptionPayload,
  DeleteEmailSubscriptionPayload,
} from '@mode/shared/schedules/contract';

export const loadReportSchedules = createAction(
  '[Report Schedules] Load Report Schedules',
  props<LoadReportSchedulesPayload>()
);
export const loadReportSchedulesSuccess = createAction(
  '[Report Schedules] Load Report Schedules Success',
  props<{ schedules: ReportSchedule[] }>()
);
export const loadReportSchedulesFailure = createAction('[Report Schedules] Load Report Schedules Failed');

export const deleteReportSchedule = createAction(
  '[Report Schedules] Delete Report Schedule',
  props<DeleteReportSchedulePayload>()
);

export const deleteReportScheduleSuccess = createAction(
  '[Report Schedules] Delete Report Schedule Success',
  props<{ scheduleId: string; successMsg: string }>()
);

export const deleteReportScheduleFailure = createAction(
  '[Report Schedules] Delete Report Schedule Failure',
  props<{ errorMsg: string }>()
);

export const createEmailSubscription = createAction(
  '[Report Schedules] Create Email Subscription',
  props<CreateEmailSubscriptionPayload>()
);

export const createEmailSubscriptionSuccess = createAction(
  '[Report Schedules]  Create Email Subscription Success',
  props<{ scheduleId: string; emailSubscription: EmailMemberships; subscriberCount: number; successMsg: string }>()
);

export const createEmailSubscriptionFailure = createAction(
  '[Report Schedules] Create Email Subscription Failure',
  props<{ errorMsg: string }>()
);

export const deleteEmailSubscription = createAction(
  '[Report Schedules] Delete Email Subscription',
  props<DeleteEmailSubscriptionPayload>()
);

export const deleteEmailSubscriptionSuccess = createAction(
  '[Report Schedules] Delete Email Subscription Success',
  props<{ scheduleId: string; subscriberCount: number; successMsg: string }>()
);

export const deleteEmailSubscriptionFailure = createAction(
  '[Report Schedules] Delete Email Subscription Failure',
  props<{ errorMsg: string }>()
);
